import React, { createRef } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from "next-i18next";
import { useRef, useEffect, useState } from "react";
import { setCookie } from 'cookies-next';
import { _postURL } from "../../api";
import { pagelink } from "@/config/site";
import Modal from 'react-modal';
import { AllMeta } from "../../../components/seo/meta";
import { useRouter } from "next/router";
import Subscription from "@/components/section/subscription";
import { Breadcrumb } from '../../../components/section/breadcrumb';
import _ from 'lodash';
import { format, parseISO } from 'date-fns';
import ReviewSection from '@/components/section/review';
import RecommendedReview from '@/components/slider/review-recommended';
import $ from 'jquery';
import { FaAngleLeft, FaAngleRight, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import LikeTheseSlider from '@/components/slider/review-possible-suggestions';
import moment from 'moment';
import { useScrollIntoView } from '@mantine/hooks';
import { motion } from 'framer-motion';
import { toast } from "@/libraries/swal";

export default function Index(props) {
    const { t: translate } = useTranslation();
    const { session } = props;
    const router = useRouter();
    const { reviewData, possibleSuggestions, rank } = props; // reviewData, possibleSuggestions is passed from getStaticProps below
    const [maxStar, setMaxStar] = useState(5);
    const [scrollTop, setScrollTop] = useState(0);
    const [reviewContent, setReviewContent] = useState(JSON.parse(reviewData.content));
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalVoteIsOpen, setModalVoteIsOpen] = useState(false);
    const [selecetedVideoIndex, setSelecetedVideoIndex] = useState(0);
    const [slideIndex, setSlideIndex] = useState(null);
    const [videoIndex, setVideoIndex] = useState(null);
    const [naviTabHeight, setNaviTabHeight] = useState(0);
    const [originalSubscriptionStatus, setOriginalSubscriptionStatus] = useState(parseInt(reviewData.subscription_status));
    const [userLogin, setUserLogin] = useState(false);
    const voteAmountDiamond = [
        5,10,50,100,500,1000,2000
    ];
    const [selectedAmount, setSelectedAmount] = useState(-1);
    const [availableDiamond, setAvailableDiamond] = useState(0);
    const [submitTextChange, setSubmitTextChange] = useState(false);
    const [confirmVoteButton, setConfirmVoteButton] = useState(false);
    // console.log(reviewContent.content[1].tab_name);
    // console.log(reviewContent.content[0].slides[0].video.length);
    const { scrollIntoView, targetRef } = useScrollIntoView({
        offset: 120,
    });

    const refs = useRef(reviewContent.content.map(() => createRef()));

    const currentPage = {
        pageName: reviewData.display_name,
        pageLink: `/review/company/${reviewData.custom_url}`
    };

    const previousPage = [{
        pageName: translate('Review'),
        pageLink: pagelink.review.homepage
    }];

    // generate filled star rating
    var fill_star_count = _.range(0, parseInt(reviewData.rating));

    // generate empty star rating
    var empty_star_count = _.range(0, maxStar - parseInt(reviewData.rating));

     // generate overall filled star rating
     var overall_fill_star_count = _.range(0, parseInt(reviewContent.overall.rating));

     // generate overall empty star rating
     var overall_empty_star_count = _.range(0, maxStar - parseInt(reviewContent.overall.rating));


    // review navigation bar horizontal
    useEffect(() => {
        const container = document.querySelector('#items-container');

        let startY;
        let startX;
        let scrollLeft;
        let scrollTop;
        let isDown;

        container.addEventListener('mousedown', e => {
            isDown = true;
            startY = e.pageY - container.offsetTop;
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
            scrollTop = container.scrollTop;
        });
        container.addEventListener('mouseup', e => {
            isDown = false;
        })
        container.addEventListener('mouseleave', e => {
            isDown = false;
        });
        container.addEventListener('mousemove', e => {
            if(isDown){
                e.preventDefault();
                //Move vertcally
                const y = e.pageY - container.offsetTop;
                const walkY = y - startY;
                container.scrollTop = scrollTop - walkY;

                //Move Horizontally
                const x = e.pageX - container.offsetLeft;
                const walkX = x - startX;
                container.scrollLeft = scrollLeft - walkX;
            }
        });
    }, []);

    // review navigation bar scrollbar
    useEffect(() => {
        const headerHeight = document.querySelector('header').offsetHeight;
        const sectionHeight = document.querySelector('.single-review-sec').offsetHeight;
        const onScroll = e => {
            setScrollTop(e.target.documentElement.scrollTop);
        };
        window.addEventListener("scroll", onScroll);

        if(scrollTop >= sectionHeight){
            // add css
            document.querySelector('#items-container').style.position = 'fixed';
            document.querySelector('#items-container').style.top = headerHeight+'px';
            document.querySelector('#items-container').style.left = 0;
            document.querySelector('#items-container').style.right = 0;
            document.querySelector('#items-container').style.zIndex = 99; // 100 blocked header dropdown
        }
        else{
            document.querySelector('#items-container').style.position = 'relative';
        }
      
        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollTop]);

    // set active tab
    useEffect(() => {
        window.addEventListener("scroll", function() {
            const tablength = reviewContent.content.length;
            for(var i = 0; i < tablength; i++){
                var tabName = document.getElementById('content-' + i);
                if(tabName){
                    // if (window.scrollY >= (tabName.offsetTop - 50)) {
                    if (window.scrollY + 1 >= (refs.current[i].current?.getBoundingClientRect().top + window.pageYOffset - 130)) {
                        var allselected = this.document.querySelectorAll('.tab-nav-link');
                        _.forEach(allselected, function(value){
                            value.classList.remove('active');
                        })
                        this.document.querySelector('#tab-' + i).classList.add('active');
                    }
                }
            }
        });
    }, [])

    // Check for scrollbar when modal is opened or closed
    useEffect(() => {
        const body = document.querySelector('body');
        body.style.overflow = modalIsOpen ? 'hidden' : 'auto';
    }, [modalIsOpen]);
    
    useEffect(() => {
        setNaviTabHeight(document.querySelector('.single-payment-tab').offsetHeight);
    })

    // Check for subscription status
    useEffect(() => {
        if(originalSubscriptionStatus){
            // active
            const dd = moment().diff(reviewData.subscription_end_time, 'days');
            if (dd >= 0) setOriginalSubscriptionStatus(false);
        }
        else{
            // no longer active
            setOriginalSubscriptionStatus(false);
        }
    }, []);

    // Check for user login
    useEffect(() => {
        let memberData = (session && session.user != null) ? session.user.member : '';
        // console.log(memberData);
        if(!_.isEmpty(memberData)){
            setUserLogin(true);
            setAvailableDiamond(Number(memberData.available_diamond).toFixed(0));
        }
    }, []);

    // set active tab when clicked
    const _setActiveTab = (key) => {
        const target = refs.current[key].current.getBoundingClientRect();
        
        const allselected = document.querySelectorAll('.tab-nav-link');
        _.forEach(allselected, function(value){
            value.classList.remove('active');
        });
        document.querySelector('#tab-' + key).classList.add('active');
        window.scrollTo({
            top: target.top + window.pageYOffset - 130,
            behavior: 'smooth'
        })
    }

    // submit vote
    const _confirmSubmitRank =  async ({companyId, diamondAmount}) => {
        setSubmitTextChange(true);
        setConfirmVoteButton(true);
        if(userLogin){
            let memberData = (session && session.user != null) ? session.user.member : '';
            if(diamondAmount != -1){
                // Proceed
                if(availableDiamond < diamondAmount){
                    toast.error("Please topup to vote");
                }
                else{
                    let req = {
                        "user_id" : !_.isEmpty(memberData.member_id) ? memberData.member_id: 0,
                        "company_id": parseInt(companyId),
                        "amount": diamondAmount
                    }
                    let result = await _postURL("/api/user/submitVote", {...req});
                    if(!_.isEmpty(result.data)){
                        toast.success(result.message, true);
                        let userData = result.data;
                        setCookie('user', JSON.stringify({ ['member']: userData }), { maxAge: "21600" });
                        
                        // reload after 2 seconds
                        setTimeout(function(){
                            window.location = location.pathname;
                        }, 2000);
                    }
                    else{
                        toast.error(result.message);
                    }
                }
            }
            else{
                toast.error("Please select diamond amount");
            }

        }
        else{
            // Redirect to Login
            window.location = pagelink.authentication.login;
        }
    }

    const _openModal = () => {
        setSelecetedVideoIndex(0);
        setModalIsOpen(true);
    }

    const _closeModal = () => {
        setModalIsOpen(false);
    }

    const _openVoteModal = () => {
        setModalVoteIsOpen(true);
    }

    const _closeVoteModal = () => {
        setModalVoteIsOpen(false);
    }

    return (
        <>
            <style dangerouslySetInnerHTML={{__html: `
                .bounce {
                    animation: bounce 2s ease infinite;
                }
                @keyframes bounce {
                    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
                    40% {transform: translateY(-20px);}
                    60% {transform: translateY(-15px);}
                }
            `}}></style>

            <AllMeta
                title={reviewData.meta_title}
                description={reviewData.meta_description}
                keyword={reviewData.meta_keyword}
                currentPageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${router.asPath}`}
                image={`${process.env.NEXT_PUBLIC_FS_URL}${reviewData.logo}`}
            >
                <title>{reviewData.meta_title}</title>
            </AllMeta>

            <div className="page-content">
                <section className="single-review-sec pt-5">
                    <div className="col-11 col-lg-9 mx-auto container">
                        <div className="row">
                            <div className="col-12">
                                <Breadcrumb
                                    currentPage={currentPage}
                                    previousPage={previousPage}
                                />
                                <div className="single-review-box">
                                    <span className='mobile-single-review-box-date'>{translate('Last_updated_on')} {format(parseISO(reviewData.updated_time), "dd-MM-yyyy")}</span>
                                    <div className="image-holder">
                                        <img src={`${process.env.NEXT_PUBLIC_FS_URL}${reviewData.logo}`} alt="" className="img-fluid" style={{ borderRadius: '15px' }} />
                                        <h1 className='d-lg-none'>{reviewData.display_name}</h1>
                                    </div>
                                    <div className="text-box">
                                        <div className="media">
                                            {/* <h1 className='mobile-review-box-h4'>{reviewData.display_name}</h1> */}
                                            <h1>{reviewData.display_name}</h1>
                                            <p>
                                                {originalSubscriptionStatus ?
                                                    <img src="/assets/images/verified-icon.svg" alt="" className="img-fluid" style={{ width: '30px' }} /> :
                                                    <img src="/assets/images/expired-icon.svg" alt="" className="img-fluid" style={{ width: '30px' }}/>}
                                                <a href={`/certificate/${reviewData.custom_url}`} target="_blank" className="text-black"> {!!+reviewData.subscription_status ? translate('Verified') : translate('Expired')}</a>
                                            </p>
                                            <span>{translate('Last_updated_on')} {format(parseISO(reviewData.updated_time), "dd-MM-yyyy")}</span>
                                        </div>
                                        <div className='mobile-single-review-box-h6'><img src="/assets/images/diamond-user.svg" alt="" className="img-fluid mobile-single-review-diamond" /><span> {reviewData.total_diamond} </span></div>
                                        <div className="single-review-box-button-list p-2">
                                            <ul className="ratting mt-0">
                                                {_.map(fill_star_count, fsc => (
                                                    <li key={fsc} style={{ width: '35px', height: '35px' }}><img src="/assets/images/review-star-filled.svg" alt="" className="img-fluid w-100" /></li>
                                                ))}
                                                {_.map(empty_star_count, esc => (
                                                    <li key={esc} style={{ width: '35px', height: '35px' }}><img src="/assets/images/review-star-empty.svg" alt="" className="img-fluid w-100" /></li>
                                                ))}
                                            </ul>
                                            {/* <a rel="nofollow" href={reviewData.url} target="_blank" className="visit-btn mt-xl-0 ms-xl-4 mx-auto mt-3" style={{ pointerEvents: !!+reviewData.subscription_status ?  '' : 'none', cursor: !!+reviewData.subscription_status ? '' : 'default', backgroundColor: !!+reviewData.subscription_status ? '#47b459' : '#acacac', }}>
                                                {translate('Visit_website')}
                                            </a> */}
                                            {originalSubscriptionStatus ? 
                                                <a rel="nofollow" href={reviewData.url} target="_blank" className="visit-btn mt-xl-0 ms-xl-4 mx-auto mt-3">
                                                    {translate('Visit_website')}
                                                </a> 
                                                :
                                                <a className="visit-btn mt-xl-0 ms-xl-4 mx-auto mt-3" style={{ pointerEvents: 'none', cursor: 'default', backgroundColor: '#acacac' }}>
                                                    {translate('Visit_website')}
                                                </a> 
                                            }
                                        </div>
                                        <h6><img src="/assets/images/diamond-user.svg" alt="" className="img-fluid" />
                                            <span> {reviewData.total_diamond} </span>
                                            &nbsp; {translate('Rank')} #{reviewData.ranking}
                                        </h6>
                                        <div className="review-progress-field">
                                            <div className="progress review-progress-sec">
                                                <div className="progress-bar review-progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: reviewData.diamond_percentage+'%'}} 
                                                    aria-valuenow={reviewData.diamond_percentage} aria-valuemin="0" aria-valuemax="100">
                                                    <div className="review-progress-bar-percentage">{Number(reviewData.diamond_percentage).toFixed(0)}%</div>
                                                    <div className="review-progress-bar-subtitle">of total votes</div>
                                                </div>
                                            </div>
                                            <div className="rank-diamond" style={{ left: reviewData.diamond_percentage+'%'}}>
                                                <img src="/assets/images/left-arrow.png" alt="" className="img-fluid" />
                                                {userLogin ? 
                                                <a onClick={ () => { _openVoteModal() } } style={{ cursor: 'pointer' }}>
                                                    <span className='bounce'><img src="/assets/images/diamond-user.svg" alt="" className="img-fluid" /></span>
                                                </a> :
                                                <span className='bounce'><img src="/assets/images/diamond-user.svg" alt="" className="img-fluid" /></span> }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-review-pros">
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="single-pros-inner">
                                                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link active" id="pills-basic-detail-tab"
                                                            data-bs-toggle="pill" data-bs-target="#pills-basic-detail"
                                                            type="button" role="tab" aria-controls="pills-basic-detail"
                                                            aria-selected="true">{translate('Basic_details')}
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-more-detail-tab"
                                                            data-bs-toggle="pill" data-bs-target="#pills-more-detail"
                                                            type="button" role="tab" aria-controls="pills-more-detail"
                                                            aria-selected="false">{translate('More_details')}
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-payment-detail-tab"
                                                            data-bs-toggle="pill" data-bs-target="#pills-payment-detail"
                                                            type="button" role="tab" aria-controls="pills-payment-detail"
                                                            aria-selected="false">{translate('Payment_details')}
                                                        </button>
                                                    </li>
                                                </ul>
                                                <div className="tab-content" id="pills-tabContent">
                                                    <div className="tab-pane show active" id="pills-basic-detail"
                                                        role="tabpanel" aria-labelledby="pills-basic-detail-tab">
                                                        <div className="single-pros-box">
                                                            <div className="basic-detail">
                                                                <ul>
                                                                    <li><span>{translate('Games')}:</span><span>{reviewContent.summary.basic_detail.games}</span></li>
                                                                    <li><span>{translate('License')}:</span><span>{reviewContent.summary.basic_detail.license}</span></li>
                                                                    <li><span>{translate('Support')}:</span><span>{reviewContent.summary.basic_detail.support}</span></li>
                                                                    <li><span>{translate('Launched')}:</span><span>{reviewContent.summary.basic_detail.launched}</span></li>
                                                                    <li><span>{translate('Games_type')}:</span><span>{reviewContent.summary.basic_detail.games_type}</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane" id="pills-more-detail" 
                                                        role="tabpanel" aria-labelledby="pills-more-detail-tab">
                                                        <div className="single-pros-box">
                                                            <div className="basic-detail">
                                                                <ul>
                                                                    <li><span>{translate('Social_media')}</span><span>{reviewContent.summary.more_detail.social_media}</span></li>
                                                                    <li><span>{translate('Bonuses')}:</span><span>{reviewContent.summary.more_detail.bonuses}</span></li>
                                                                    <li><span>{translate('Vip_program')}:</span><span>{reviewContent.summary.more_detail.vip_program}</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane" id="pills-payment-detail" 
                                                        role="tabpanel" aria-labelledby="pills-payment-detail-tab">
                                                        <div className="single-pros-box">
                                                            <div className="basic-detail">
                                                                <ul>
                                                                    <li><span>{translate('Min_deposit')}:</span><span>{reviewContent.summary.payment_detail.min_deposit}</span></li>
                                                                    <li><span>{translate('Min_withdrawal')}:</span><span>{reviewContent.summary.payment_detail.min_withdrawal}</span></li>
                                                                    <li><span>{translate('Currencies')}:</span><span>{reviewContent.summary.payment_detail.currencies}</span></li>
                                                                    <li><span>{translate('Methods')}:</span><span>{reviewContent.summary.payment_detail.methods}</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6">
                                            <div className="single-pros-inner">
                                                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link active" id="pills-pros-tab"
                                                            data-bs-toggle="pill" data-bs-target="#pills-pros"
                                                            type="button" role="tab" aria-controls="pills-pros"
                                                            aria-selected="true">{translate('Pros')}
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-cons-tab"
                                                            data-bs-toggle="pill" data-bs-target="#pills-cons"
                                                            type="button" role="tab" aria-controls="pills-cons"
                                                            aria-selected="false">{translate('Cons')}
                                                        </button>
                                                    </li>
                                                </ul>
                                                <div className="tab-content" id="pills-tabContent">
                                                    <div className="tab-pane fade show active" id="pills-pros"
                                                        role="tabpanel" aria-labelledby="pills-pros-tab">
                                                        <div className="single-pros-box">
                                                            <div className="cons-detail">
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <div className="cons-box">
                                                                            <h4>{translate('Pros')}</h4>
                                                                            <ul>
                                                                                {_.reduce(reviewContent.summary.pros, function(result, value, key) {
                                                                                    result.push(<li key={key}>
                                                                                        <div className='d-flex align-items-center'><span style={{ fontSize: '30px' }}><FaCheckCircle className='me-3' style={{ color: '#43a047' }} /></span>{value}</div><br />
                                                                                        {/* <img src="/assets/images/tick-icon.png" alt="" />{value}<br /> */}
                                                                                    </li>)
                                                                                    return result;
                                                                                },[])}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="pills-cons" 
                                                        role="tabpanel" aria-labelledby="pills-cons-tab">
                                                        <div className="single-pros-box">
                                                            <div className="cons-detail">
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <div className="cons-box">
                                                                            <h4>{translate('Cons')}</h4>
                                                                            <ul>
                                                                                {_.reduce(reviewContent.summary.cons, function(result, value, key) {
                                                                                    result.push(<li key={key}>
                                                                                        <div className='d-flex align-items-center'><span style={{ fontSize: '30px' }}><FaTimesCircle className='me-3' style={{ color: '#ef393b' }} /></span>{value}</div><br />
                                                                                        {/* <img src="/assets/images/cross-icon.png" alt="" />{value}<br /> */}
                                                                                    </li>)
                                                                                    return result;
                                                                                },[])}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="single-payment-review">
                    <div className="single-payment-tab" id="items-container">
                        <ul className="nav nav-pills" id="pills-tab">
                            {_.reduce(reviewContent.content, function(result, value, key) {
                                // var tabName = value.tab_name.toLowerCase().replace(/ /g,'');
                                result.push(<li className="nav-item" key={key} style={{ cursor: 'pointer' }}>
                                    <a className={ key == 0 ? "tab-nav-link nav-link active" : "tab-nav-link nav-link" } id={"tab-"+key} onClick={() => { _setActiveTab(key) }}>
                                        {value.tab_name}
                                    </a>
                                </li>)
                                return result;
                            },[])}
                        </ul>
                    </div>
                    <div className="col-11 col-lg-9 mx-auto container" style={{ paddingTop: naviTabHeight }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="tab-content" id="pills-tabContent">
                                {_.reduce(reviewContent.content, function(result, value, key) {
                                    result.push(
                                        <div ref={refs.current[key]} id={'content-'+key} key={key} style={{ paddingTop: '40px' }}>
                                            <ReviewSection
                                                subscriptionStatus={originalSubscriptionStatus}
                                                reviewSectionContent={value}
                                                providerContent={reviewContent.provider}
                                                openModal={_openModal}
                                                setSlideIndex={setSlideIndex}
                                                setVideoIndex={setVideoIndex}
                                                slideNumber={key}
                                                {...props}
                                            />
                                        </div>
                                    )
                                    return result;
                                },[])}
                                </div>
                                <div className="payment-review-box overall-summary-sec pt-5">
                                    <div className="media">
                                        <span>
                                            {originalSubscriptionStatus ?
                                                <img src="/assets/images/verified-icon.svg" alt="" className="img-fluid"/> :
                                                <img src="/assets/images/expired-icon.png" alt="" className="img-fluid"/>}
                                        </span>
                                        <ul className="ratting mt-0">
                                            {_.map(overall_fill_star_count, fsc => (
                                                <li key={fsc} style={{ width: '35px', height: '35px' }}><img src="/assets/images/review-star-filled.svg" alt="" className="img-fluid w-100" /></li>
                                            ))}
                                            {_.map(overall_empty_star_count, esc => (
                                                <li key={esc} style={{ width: '35px', height: '35px' }}><img src="/assets/images/review-star-empty.svg" alt="" className="img-fluid w-100" /></li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="text-box">
                                        <h1>{translate('Overall_summary')}</h1>
                                        <p dangerouslySetInnerHTML={{ __html: reviewContent.overall.text_content }} />
                                    </div>
                                </div>
                                
                                <LikeTheseSlider suggestionData={possibleSuggestions} title={translate('Recommended_reviews')} {...props}/>
                                {/* <div className="payment-review-box recommended-sec">
                                    <div className="text-box">
                                        <h1>{translate('Recommended_reviews')}</h1>
                                        <RecommendedReview 
                                            possibleSuggestionsList={possibleSuggestions} 
                                            {...props} />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/** Subscription Part */}
            <Subscription {...props}/>

            {/** Modal part */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => { _closeModal() }}
                ariaHideApp={false}
                portalClassName={"modal-video"}
                className={"video-modalOpened review-modalOpened modal-lg"}
                overlayClassName={"contact-modalOverlayOpened"}
                style={{
                    content: {
                        margin: "150px auto",
                        outline: "none",
                        padding: "0 20px"
                    }
                }}
                aria={{ labelledby: "exampleModalLabel" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="btn-close" onClick={() => { _closeModal() }}>
                                <img src="/assets/images/cross-white-icon.png" alt="" />
                            </button>
                            <div style={{ textAlign: 'center' }}>
                                {/* <iframe width="460" height="349"
                                    src={process.env.NEXT_PUBLIC_FS_URL+reviewContent.content[slideIndex]?.slides[videoIndex]?.video[selecetedVideoIndex]}
                                    title="Content video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; muted; loop; playsinline"
                                    allowFullScreen></iframe> */}
                                <video width="100%" height="auto" controls
                                    src={process.env.NEXT_PUBLIC_FS_URL+reviewContent.content[slideIndex]?.slides[videoIndex]?.video[selecetedVideoIndex]}
                                    autoPlay="autoplay" muted loop playsInline
                                    ></video>
                            </div>
                            <div className='d-flex'>
                                <div className="next-btn justify-content-start" style={{ visibility: selecetedVideoIndex === 0 ? 'hidden' : 'visible', cursor: 'pointer' }} onClick={()=>{ setSelecetedVideoIndex(selecetedVideoIndex - 1) }}><FaAngleLeft color='#bb9b6a'/>{translate('Previous Video')}</div>
                                <div className="next-btn" style={{ visibility: selecetedVideoIndex + 1 < reviewContent.content[slideIndex]?.slides[videoIndex]?.video.length ? 'visible' : 'hidden', cursor: 'pointer' }} onClick={()=>{ setSelecetedVideoIndex(selecetedVideoIndex + 1) }}>{translate('Next_video')}<FaAngleRight color='#bb9b6a'/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>      

            { /* Voting modal */ }
            <Modal
                isOpen={modalVoteIsOpen}
                onRequestClose={() => { _closeVoteModal() }}
                ariaHideApp={false}
                portalClassName={"modal-video"}
                className={"video-modalOpened review-modalOpened modal-lg"}
                overlayClassName={"contact-modalOverlayOpened"}
                style={{
                    content: {
                        margin: "150px auto",
                        outline: "none",
                        padding: "0 20px"
                    }
                }}
                aria={{ labelledby: "exampleModalLabel" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                        <div className='position-relative d-flex align-items-center justify-content-center'>
                            <h3 className='custom_h3'>{translate('Select_diamond')}</h3>
                        </div>
                            <button type="button" className="btn-close" onClick={() => { _closeVoteModal() }}>
                                <img src="/assets/images/cross-white-icon.png" alt="" />
                            </button>
                            <div className='vote-ranking-diamondRankingBoard-mobile-modal-voteConfirm'>
                                <div className='d-flex flex-wrap justify-content-center'>
                                    {
                                        _.reduce(voteAmountDiamond, (result, value, key) => {
                                            result.push(
                                                <div 
                                                    className={value === selectedAmount ? 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button-active' : 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button'} 
                                                    key={key}
                                                    onClick={()=>{setSelectedAmount(value), setSubmitTextChange(false)}}
                                                >
                                                    <p className='custom_p2'>
                                                        <strong>{value}</strong>
                                                    </p>
                                                </div>
                                            )
                                            return result;
                                        }, [])
                                    }
                                    <div 
                                        className={availableDiamond === selectedAmount ? 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button-active' : 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button'} 
                                        onClick={()=>{setSelectedAmount(availableDiamond), setSubmitTextChange(false)}}
                                    >
                                        <p className='custom_p2'>
                                            <strong>{translate('ALL')}</strong>
                                        </p>
                                    </div>
                                </div>
                                <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column'>
                                    {selectedAmount >= 0 &&
                                        <motion.p 
                                            className='custom_p2'
                                            initial={{opacity: 0, y: '-50px'}}
                                            animate={{opacity: 1, y: 0}}
                                        >
                                            You've {submitTextChange == true ? 'voted' : 'selected'} <strong>{selectedAmount}</strong> diamonds!
                                        </motion.p>
                                    }
                                </div>
                                {selectedAmount >= 0 &&
                                    <motion.div 
                                        className='my-2'
                                        initial={{opacity: 0, y: '-50px'}}
                                        animate={{opacity: 1, y: 0}}
                                    >
                                        <p className='custom_p3 text-center'>
                                            {translate('preview')}
                                        </p>
                                        <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-remainWallet'>
                                            <p className='custom_p2'>
                                                <strong>{availableDiamond}</strong>
                                            </p>
                                            <p className='custom_p3 custom_colorRed'>
                                                <strong>{selectedAmount >= 0 && '-' + selectedAmount}</strong>
                                            </p>
                                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-remainWallet-image' style={{ left: '-30.5px', width: '60px', top: '-3px' }}>
                                                <img src="/assets/images/diamond-icon.png" alt="" className="img-fluid w-100" />
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                                <button onClick={()=>{_confirmSubmitRank({companyId: reviewData.company_id, diamondAmount: selectedAmount})}} className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-confirm-button' disabled={confirmVoteButton}>
                                    <h3 className='custom_h3 custom_colorWhite'>{translate('Confirm')}</h3>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )

}

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

export async function getStaticProps({ locale, params: { id } }) {
    try {
        const [
            { value: { data: reviewData } },
            { value: { data: possibleSuggestions } } = { data: [] },
        ] = await Promise.allSettled([
            _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/review/checkReview`, { id: id }),
            _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/review/getPossibleSuggestions`),
        ]);
        if (_.isEmpty(reviewData)) throw new Error();

        return {
            props: {
                reviewData,
                possibleSuggestions,
                ...(await serverSideTranslations(locale, ['common'])),
            },
            revalidate: 10
        };

    } catch (error) {
        return {
            notFound: true,
        }
    }
}

/*
export async function getServerSideProps ({ req, locale, params }) {
    let host = req.headers.host;    // get current host
    let protocol = req.headers.referer?.split('://')[0];    // get current protocol
    let idSplit = params.id.split('-');
    let dreq = {
        "company_id" : idSplit[idSplit.length - 1]
    }
    let result = await _postURL(`${protocol}://${host}/api/review/checkReview`, {...dreq});
    if(_.isEmpty(result.data)){
        // redirect to 404 if review not found
        return {
            notFound: true
        }
    }
    return {
        props: {
            reviewData: {
                result
            },
            currentPageLink: {
                params
            },
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}
*/